// extracted by mini-css-extract-plugin
export default {"container":"Casting_container__Whdqc"};